import React from 'react';
import { motion } from "framer-motion"
import logoSrc from '../assets/logo/322-logo.png';

const Hero = () => {
  return (
    <div className="border-b border-opacity-20 border-gray-400 dark:border-gray-600 pb-16 pt-4">
      <div className="container mx-auto px-8 flex flex-wrap lg:flex-nowrap lg:items-center">
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-6xl font-thin mt-4 lg:mt-16 lg:ml-24 text-text-primary-light dark:text-text-primary-dark"
          >
          </motion.h1>
          {['Ali Barkın Öztürk', 'Mehmet Eroğlu', 'Efe Emür', 'Berke Alabaş'].map((name, index) => (
            <motion.span
              key={name}
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2 }}
              className="bg-gradient-to-r from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark bg-clip-text text-transparent text-4xl lg:ml-24"
            >
              {name}
            </motion.span>
          ))}
        </div>
        <div className="w-full lg:w-1/2 p-0 lg:p-8 flex justify-center">
          <motion.img
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.2 }}
            src={logoSrc}
            className="max-w-full h-auto rounded-lg"
            alt="Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;